var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-lg max-w-3xl"},[_c('h1',{staticClass:"text-2xl font-black mb-4"},[_vm._v("Page not found (404 error)")])])}]

export { render, staticRenderFns }